'use client'

import type {
  AdditionalServiceItemProps,
  BuildingBlockDayToDayRepeaterActivitiesProps,
  RoundtripDayToDayRepeaterActivitiesProps,
} from '@typings'
import {
  RaButton,
  RaContainer,
  RaGrid,
  RaGridItem,
  RaHeading,
  RaImage,
  RaPaper,
  RaRichText,
} from '@components/core/index.core'

import { RaDayByDayInsertActivitiesModal } from './RaDayByDayInsertActivitiesModal'

import styles from './ra-day-by-day-insert-activities.module.scss'

import { useUi } from '@/contexts/ui.context'
import { translate } from '@/utilities/helpers/translate.helpers'

interface RaDayByDayInsertActivitiesProps {
  item: BuildingBlockDayToDayRepeaterActivitiesProps | RoundtripDayToDayRepeaterActivitiesProps
  maxWidth?: number
}

export const RaDayByDayInsertActivities = ({ item, maxWidth }: RaDayByDayInsertActivitiesProps) => {
  const { showModal } = useUi()

  const renderModal = (item: AdditionalServiceItemProps) => {
    showModal({
      maxWidth: 800,
      title: item.headline,
      content: <RaDayByDayInsertActivitiesModal {...item} />,
    })
  }

  return (
    <RaContainer maxWidth={maxWidth}>
      <div className={styles['activities']}>
        {item.activities.map((activity: AdditionalServiceItemProps) => (
          <RaPaper
            key={activity.gid}
            padding={6}
            paddingMobile={4}
            hoverAnimations={['shadow']}
            tornEdge>
            <RaGrid gap={48}>
              <RaGridItem md={8}>
                <RaImage image={activity.slideshow[0]} />
              </RaGridItem>
              <RaGridItem
                flex="col"
                justify="center"
                md={8}
                lg={8}>
                <RaHeading component="h4">{activity.headline}</RaHeading>
                <RaRichText content={activity.content} />
                <div>
                  <RaButton
                    onClick={() => renderModal(activity)}
                    label={translate('READ_MORE')}
                  />
                </div>
              </RaGridItem>
            </RaGrid>
          </RaPaper>
        ))}
      </div>
    </RaContainer>
  )
}
